import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  :root {
    color-scheme: light;
    --page: #ffffff;
    --surface: #ffffff;
    --text: #444444;
    --heading: #333333;
    --muted: #777777;
    --subtle: #666666;
    --line: #e0e0e0;
    --nav-surface: rgba(255, 255, 255, 0.96);
    --paper: #faf8f0;
    --paper-text: #3f3e39;
    --paper-muted: #66635d;
    --paper-stage: #5b5c5a;
    --project-emphasis: #17384a;
    --project-link: #1a607f;
    --protected-fade-soft: rgba(255, 255, 255, 0.28);
    --protected-fade-strong: rgba(255, 255, 255, 0.76);
    --illustration-filter: none;
    --social-icon-filter: none;
    --selection: #ffebb8;
  }

  :root[data-theme="dark"] {
    color-scheme: dark;
    --page: #171715;
    --surface: #201f1c;
    --text: #e8e5dd;
    --heading: #f5f2ea;
    --muted: #aaa69c;
    --subtle: #c5c0b6;
    --line: #3b3934;
    --nav-surface: rgba(23, 23, 21, 0.94);
    --paper: #29261f;
    --paper-text: #eee8da;
    --paper-muted: #c6bfb0;
    --paper-stage: #0f0f0e;
    --project-emphasis: #b9e6f5;
    --project-link: #80d6f4;
    --protected-fade-soft: rgba(23, 23, 21, 0.28);
    --protected-fade-strong: rgba(23, 23, 21, 0.82);
    --illustration-filter: invert(0.92) hue-rotate(180deg) brightness(0.9);
    --social-icon-filter: invert(1) grayscale(1) brightness(1.8);
    --selection: #5f542f;
  }

  html,
  body,
  #root {
    min-height: 100%;
    background: var(--page);
  }

  body {
    font-family: 'Aktiv Grotesk Corp', 'DM Sans', system-ui;
    color: var(--text);
    transition: background-color 0.24s ease, color 0.24s ease;
  }

   &::-moz-selection { /* Code for Firefox */
      background-color: var(--selection);
    }
    
   &::selection {
      background-color: var(--selection);
   }
`;

export default GlobalStyle;
